import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { textTrigger } from './animation';
import { RifaService } from '../rifa.service';

@Component({
  selector: 'app-ganador',
  templateUrl: './ganador.component.html',
  styleUrls: ['./ganador.component.css'],
  animations: [textTrigger]
})
export class GanadorComponent implements OnInit {

  @Input() mensaje_inicial;
  @Input() mensaje_ganador;

  @Output() continue = new EventEmitter<void>();
  @Output() reiniciar_tombola = new EventEmitter<void>();

  mensaje = '';
  textState = 'noDisplayText';
  mostrar_avion = true;
  mostrar_elimindoPart = false;
  mostrar_final = false;
  mensajeFinal = '<PantallaFinalRifa/>'
  premio = '';
  patrocinador = '';
  keyRifa = '';
  imagenRifa = '';

  constructor(private rifaService: RifaService) { }

  ngOnInit() {

    this.premio = localStorage.getItem('premio');
    this.patrocinador = localStorage.getItem('patrocinador');
    this.keyRifa = localStorage.getItem('key');
    
    this.imagenRifa = localStorage.getItem('imagen');

    const duracion_gif = 5000;
    const duracion_texto = 4500;

    setTimeout(() => {
      // console.log('SET_TIMEOUT 1 GANADOR');
      this.mostrar_elimindoPart = false;
      this.cambiarEstado();
    }, duracion_texto);

    setTimeout(() => {
      // console.log('SET_TIMEOUT 2 GANADOR');
      this.mostrar_avion = false;
      this.mostrar_final = true;
    }, duracion_gif);

    setTimeout(()=>{
      // console.log('SET_INTERVAL 1 GANADOR');
      this.mostrar_elimindoPart = true;
    },2650);

    this.mensaje = this.mensaje_inicial;
    this.textState = 'displayText';

    setTimeout(() => {
      // console.log('SET_TIMEOUT 3 GANADOR');
      this.textState = 'noDisplayText';
      this.mostrarMensajeGanador();
    }, duracion_gif + 2000);
  }

  mostrarMensajeGanador() {
    setTimeout(() => {
      // console.log('SET_TIMEOUT 4 GANADOR');
      this.mensaje = this.mensaje_ganador;
      this.textState = 'displayText';
    }, 3000);
  }

  next() {
    this.continue.emit();
  }


  cambiarEstado(){
    this.rifaService.ganador(this.mensaje_ganador,this.keyRifa);  
  }

  async reload(){
    localStorage.clear();
    location.reload();
  }

  async reload_conPremio(){
    // localStorage.clear();
    this.reiniciar_tombola.emit();
  }

}
